export default __webpack_public_path__ + "static/media/Page17.fddd3d38.txt";